import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "wine-add-btn",
    on: {
      click: function click($event) {
        !_vm.loading && _vm.click();
      }
    }
  }, [_vm.loading ? _c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "25",
      width: "2"
    }
  }) : _c("i", {
    staticClass: "fas fa-cart-plus",
    class: _vm.isStockIncompatible ? "stock-warning" : "",
    attrs: {
      title: "Add product to cart"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };